module.exports = __webpack_public_path__ + "img/ios_download-icon.555c4d5a.png";